// frontend/src/utils/formatters.js
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '0 HTG';
  
  const number = typeof value === 'string' ? parseFloat(value) : value;
  
  return new Intl.NumberFormat('fr-HT', {
    style: 'currency',
    currency: 'HTG',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(number);
};

export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export const formatDateShort = (dateString) => {
  if (!dateString) return '-';
  
  const date = new Date(dateString);
  
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Format: 3XXX-XXXX-XXXXX
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 8) {
    return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2');
  }
  
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  
  return phone;
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined) return '0%';
  
  const number = typeof value === 'string' ? parseFloat(value) : value;
  
  return new Intl.NumberFormat('fr-FR', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  }).format(number / 100);
};

export const formatPoints = (points) => {
  if (points === null || points === undefined) return '0';
  
  return new Intl.NumberFormat('fr-FR').format(points);
};